/* Options:
Date: 2021-07-07 22:03:13
Version: 5.110
Tip: To override a DTO option, remove "//" prefix before updating
BaseUrl: https://an3b0ihj5e.execute-api.us-east-2.amazonaws.com/prod

//GlobalNamespace: 
//MakePropertiesOptional: False
//AddServiceStackTypes: True
//AddResponseStatus: False
//AddImplicitVersion: 
//AddDescriptionAsComments: True
//IncludeTypes: 
//ExcludeTypes: 
//DefaultImports: 
*/


export interface IReturn<T>
{
    createResponse(): T;
}

export interface IReturnVoid
{
    createResponse(): void;
}

export interface IHasSessionId
{
    sessionId: string;
}

export interface IHasBearerToken
{
    bearerToken: string;
}

export interface IPost
{
}

export class WorkstationActionExecutionResult
{
    public id: string;

    public constructor(init?: Partial<WorkstationActionExecutionResult>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ResponseError
{
    // @DataMember(Order=1)
    public errorCode: string;

    // @DataMember(Order=2)
    public fieldName: string;

    // @DataMember(Order=3)
    public message: string;

    // @DataMember(Order=4)
    public meta: { [index: string]: string; };

    public constructor(init?: Partial<ResponseError>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ResponseStatus
{
    // @DataMember(Order=1)
    public errorCode: string;

    // @DataMember(Order=2)
    public message: string;

    // @DataMember(Order=3)
    public stackTrace: string;

    // @DataMember(Order=4)
    public errors: ResponseError[];

    // @DataMember(Order=5)
    public meta: { [index: string]: string; };

    public constructor(init?: Partial<ResponseStatus>) { (Object as any).assign(this, init); }
}

export class WorkstationDetails
{
    public userName: string;
    public hostAddress: string;
    public cloudProviderWorkstationId: string;
    public email: string;
    public company: string;
    public workstationDescription: string;

    public constructor(init?: Partial<WorkstationDetails>) { (Object as any).assign(this, init); }
}

export enum WorkstationStatus
{
    None = 'None',
    Stopping = 'Stopping',
    Starting = 'Starting',
    Running = 'Running',
    Stopped = 'Stopped',
    Modifying = 'Modifying',
}

export class StopWorkstationResponse
{
    public result: WorkstationActionExecutionResult;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<StopWorkstationResponse>) { (Object as any).assign(this, init); }
}

export class WhitelistIpAddressResponse
{
    public result: WorkstationActionExecutionResult;
    public responseError: ResponseStatus;

    public constructor(init?: Partial<WhitelistIpAddressResponse>) { (Object as any).assign(this, init); }
}

export class GetWorkstationDetailsResponse
{
    public result: WorkstationDetails;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<GetWorkstationDetailsResponse>) { (Object as any).assign(this, init); }
}

export class GetWorkstationStatusResponse
{
    public responseStatus: ResponseStatus;
    public result: WorkstationStatus;

    public constructor(init?: Partial<GetWorkstationStatusResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class AuthenticateResponse implements IHasSessionId, IHasBearerToken
{
    // @DataMember(Order=1)
    public userId: string;

    // @DataMember(Order=2)
    public sessionId: string;

    // @DataMember(Order=3)
    public userName: string;

    // @DataMember(Order=4)
    public displayName: string;

    // @DataMember(Order=5)
    public referrerUrl: string;

    // @DataMember(Order=6)
    public bearerToken: string;

    // @DataMember(Order=7)
    public refreshToken: string;

    // @DataMember(Order=8)
    public profileUrl: string;

    // @DataMember(Order=9)
    public roles: string[];

    // @DataMember(Order=10)
    public permissions: string[];

    // @DataMember(Order=11)
    public responseStatus: ResponseStatus;

    // @DataMember(Order=12)
    public meta: { [index: string]: string; };

    public constructor(init?: Partial<AuthenticateResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class AssignRolesResponse
{
    // @DataMember(Order=1)
    public allRoles: string[];

    // @DataMember(Order=2)
    public allPermissions: string[];

    // @DataMember(Order=3)
    public meta: { [index: string]: string; };

    // @DataMember(Order=4)
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<AssignRolesResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class UnAssignRolesResponse
{
    // @DataMember(Order=1)
    public allRoles: string[];

    // @DataMember(Order=2)
    public allPermissions: string[];

    // @DataMember(Order=3)
    public meta: { [index: string]: string; };

    // @DataMember(Order=4)
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<UnAssignRolesResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ConvertSessionToTokenResponse
{
    // @DataMember(Order=1)
    public meta: { [index: string]: string; };

    // @DataMember(Order=2)
    public accessToken: string;

    // @DataMember(Order=3)
    public refreshToken: string;

    // @DataMember(Order=4)
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<ConvertSessionToTokenResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class GetAccessTokenResponse
{
    // @DataMember(Order=1)
    public accessToken: string;

    // @DataMember(Order=2)
    public meta: { [index: string]: string; };

    // @DataMember(Order=3)
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<GetAccessTokenResponse>) { (Object as any).assign(this, init); }
}

/**
* ContactSupport
*/
// @Route("/support", "POST")
// @Api(Description="ContactSupport")
export class ContactSupport implements IReturnVoid, IPost
{
    /**
    * User's Feedback
    */
    // @ApiMember(DataType="string", Description="User's Feedback", IsRequired=true, Name="Feedback")
    public feedback: string;

    /**
    * Subject
    */
    // @ApiMember(DataType="string", Description="Subject", IsRequired=true, Name="Subject")
    public subject: string;

    public constructor(init?: Partial<ContactSupport>) { (Object as any).assign(this, init); }
    public createResponse() {}
    public getTypeName() { return 'ContactSupport'; }
}

/**
* StartWorkstation
*/
// @Route("/workstation/{id}/start", "POST")
// @Api(Description="StartWorkstation")
export class StartWorkstation implements IReturn<StopWorkstationResponse>, IPost
{
    public id: string;

    public constructor(init?: Partial<StartWorkstation>) { (Object as any).assign(this, init); }
    public createResponse() { return new StopWorkstationResponse(); }
    public getTypeName() { return 'StartWorkstation'; }
}

/**
* StopWorkstation
*/
// @Route("/workstation/{id}/stop", "POST")
// @Api(Description="StopWorkstation")
export class StopWorkstation implements IReturn<StopWorkstationResponse>, IPost
{
    public id: string;

    public constructor(init?: Partial<StopWorkstation>) { (Object as any).assign(this, init); }
    public createResponse() { return new StopWorkstationResponse(); }
    public getTypeName() { return 'StopWorkstation'; }
}

/**
* WhitelistIpAddress
*/
// @Route("/workstation/whitelist", "POST")
// @Api(Description="WhitelistIpAddress")
export class WhitelistIpAddress implements IReturn<WhitelistIpAddressResponse>, IPost
{

    public constructor(init?: Partial<WhitelistIpAddress>) { (Object as any).assign(this, init); }
    public createResponse() { return new WhitelistIpAddressResponse(); }
    public getTypeName() { return 'WhitelistIpAddress'; }
}

// @Route("/workstation/{id}/details", "GET")
export class GetWorkstationDetails implements IReturn<GetWorkstationDetailsResponse>
{
    public id: string;

    public constructor(init?: Partial<GetWorkstationDetails>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetWorkstationDetailsResponse(); }
    public getTypeName() { return 'GetWorkstationDetails'; }
}

// @Route("/workstation/{id}/status", "GET")
export class GetWorkstationStatus implements IReturn<GetWorkstationStatusResponse>
{
    /**
    * Instance Id
    */
    // @ApiMember(DataType="string", Description="Instance Id", Name="Id", ParameterType="query")
    public id: string;

    public constructor(init?: Partial<GetWorkstationStatus>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetWorkstationStatusResponse(); }
    public getTypeName() { return 'GetWorkstationStatus'; }
}

// @Route("/auth")
// @Route("/auth/{provider}")
// @DataContract
export class Authenticate implements IReturn<AuthenticateResponse>, IPost
{
    // @DataMember(Order=1)
    public provider: string;

    // @DataMember(Order=2)
    public state: string;

    // @DataMember(Order=3)
    public oauth_token: string;

    // @DataMember(Order=4)
    public oauth_verifier: string;

    // @DataMember(Order=5)
    public userName: string;

    // @DataMember(Order=6)
    public password: string;

    // @DataMember(Order=7)
    public rememberMe?: boolean;

    // @DataMember(Order=9)
    public errorView: string;

    // @DataMember(Order=10)
    public nonce: string;

    // @DataMember(Order=11)
    public uri: string;

    // @DataMember(Order=12)
    public response: string;

    // @DataMember(Order=13)
    public qop: string;

    // @DataMember(Order=14)
    public nc: string;

    // @DataMember(Order=15)
    public cnonce: string;

    // @DataMember(Order=16)
    public useTokenCookie?: boolean;

    // @DataMember(Order=17)
    public accessToken: string;

    // @DataMember(Order=18)
    public accessTokenSecret: string;

    // @DataMember(Order=19)
    public scope: string;

    // @DataMember(Order=20)
    public meta: { [index: string]: string; };

    public constructor(init?: Partial<Authenticate>) { (Object as any).assign(this, init); }
    public createResponse() { return new AuthenticateResponse(); }
    public getTypeName() { return 'Authenticate'; }
}

// @Route("/assignroles")
// @DataContract
export class AssignRoles implements IReturn<AssignRolesResponse>, IPost
{
    // @DataMember(Order=1)
    public userName: string;

    // @DataMember(Order=2)
    public permissions: string[];

    // @DataMember(Order=3)
    public roles: string[];

    // @DataMember(Order=4)
    public meta: { [index: string]: string; };

    public constructor(init?: Partial<AssignRoles>) { (Object as any).assign(this, init); }
    public createResponse() { return new AssignRolesResponse(); }
    public getTypeName() { return 'AssignRoles'; }
}

// @Route("/unassignroles")
// @DataContract
export class UnAssignRoles implements IReturn<UnAssignRolesResponse>, IPost
{
    // @DataMember(Order=1)
    public userName: string;

    // @DataMember(Order=2)
    public permissions: string[];

    // @DataMember(Order=3)
    public roles: string[];

    // @DataMember(Order=4)
    public meta: { [index: string]: string; };

    public constructor(init?: Partial<UnAssignRoles>) { (Object as any).assign(this, init); }
    public createResponse() { return new UnAssignRolesResponse(); }
    public getTypeName() { return 'UnAssignRoles'; }
}

// @Route("/session-to-token")
// @DataContract
export class ConvertSessionToToken implements IReturn<ConvertSessionToTokenResponse>, IPost
{
    // @DataMember(Order=1)
    public preserveSession: boolean;

    // @DataMember(Order=2)
    public meta: { [index: string]: string; };

    public constructor(init?: Partial<ConvertSessionToToken>) { (Object as any).assign(this, init); }
    public createResponse() { return new ConvertSessionToTokenResponse(); }
    public getTypeName() { return 'ConvertSessionToToken'; }
}

// @Route("/access-token")
// @DataContract
export class GetAccessToken implements IReturn<GetAccessTokenResponse>, IPost
{
    // @DataMember(Order=1)
    public refreshToken: string;

    // @DataMember(Order=2)
    public useTokenCookie?: boolean;

    // @DataMember(Order=3)
    public meta: { [index: string]: string; };

    public constructor(init?: Partial<GetAccessToken>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetAccessTokenResponse(); }
    public getTypeName() { return 'GetAccessToken'; }
}

